import React from 'react';
import './handlers';
import './subs';
import { registerPopup } from '@/ui/popupRegistrar';
import AccountMessageDialog from './views/AccountMessageDialog';

registerPopup('UserMessageDialog', popup => <AccountMessageDialog data={popup.get('data')} />);
